import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarLine from '../common/graphs/barLine';
import GraphTable from './evolutionGraphTable';

const SummaryTable = props => (
  <section className="main_table">
    <table className="table_content">
      <thead>
        <tr>
          <th className="main_table_250">{props.table}</th>
          <th className="main_table_120"> {props.language.summary.tableTitle.drivers} </th>
          <th className="main_table_120"> {props.language.summary.tableTitle.atRisk} </th>
          <th className="main_table_x2"> {props.language.summary.tableTitle.driversAtRisk}</th>
          <th className="main_table_x2"> {props.language.summary.tableTitle.distribution}</th>
        </tr>
      </thead>
      <tbody>
        {props.indicatorsByCategorization &&
          props.indicatorsByCategorization.map((item, i) => (
            <tr
              data-datos={JSON.stringify(item)}
              onClick={props.link}
              className={item.severity ? item.severity : 'OUTOFRISK'}
              key={`t-fatigue-${i}`}
            >
              <td>
                <a> {item.tag} </a>
              </td>
              <td>
                <a> {item.driversCount ? item.driversCount : '0'} </a>
              </td>
              <td>
                <a> {item.driversWithRisk ? item.driversWithRisk : '0'} </a>
              </td>
              <td>
                {item.driversRiskEvolution.fatigueRiskPercentageEvolutions.length > 0 ? (
                  <a className="special" data-tags={true} data-name={item.categorization}>
                    <GraphTable
                      graphColorRange={props.graphColorRange}
                      data={item.driversRiskEvolution.fatigueRiskPercentageEvolutions}
                      miny={true}
                      id={`graph-${i}`}
                      language={props.language}
                    />
                    <div className="main_table_num">
                      <h4>{Math.round(item.driversRiskEvolution.lastFatigueRiskPercentage)} %</h4>
                    </div>
                  </a>
                ) : (
                  <a className="special" data-tags={true} data-name={item.categorization}>
                    <div className="boxChart" />
                    <div className="main_table_num">
                      <h4>0 %</h4>
                    </div>
                  </a>
                )}
              </td>
              <td>
                <a className="special_one">
                  <BarLine
                    distribution={item.fatigueRiskDistributions}
                    language={props.language.summary.graphTooltip}
                  />
                </a>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </section>
);

export default SummaryTable;



// WEBPACK FOOTER //
// ./source/client/components/summary_fatigue/summaryTable.jsx